var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('base-form',{ref:"roundForm",staticClass:"w-full",attrs:{"fields-in-row":3,"form-data":_vm.roundForm,"edit-record":_vm.golfRound},on:{"submitted":_vm.save}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }